import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-blank-page',
    templateUrl: './blank-page.component.html',
    styleUrls: ['./blank-page.component.scss'],
})
export class BlankPageComponent {
  @Input() headline: string;
  @Input() text: string;
}
